import React from 'react';

// CB:BEGIN email-preview-report-ordered
const EmailReportOrdered: React.FC = () => {
  const address = '123 Rosewood Way, O\'Fallon, MO 63366';
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#f8f9fa', padding: 20, borderRadius: 8, marginBottom: 20 }}>
        <h2 style={{ color: '#2563eb', margin: 0 }}>Your Roof Report is On the Way</h2>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Great news! We've received your order for a detailed roof report for your property at:
      </p>
      <div style={{ background: '#f3f4f6', padding: 15, borderRadius: 6, margin: '20px 0', borderLeft: '4px solid #2563eb' }}>
        <p style={{ fontSize: 16, fontWeight: 600, margin: 0, color: '#1f2937' }}>{address}</p>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}><strong>What happens next:</strong></p>
      <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <li>Our team is processing your aerial imagery request</li>
        <li>We'll analyze your roof structure and measurements</li>
        <li>You'll receive a comprehensive report with detailed findings</li>
        <li>Once ready, you can start receiving contractor bids</li>
      </ul>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        We'll email you as soon as your report is ready. This typically takes 24-48 hours.
      </p>
      <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '30px 0' }} />
      <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        From: CoreBids Notifications &lt;notifications@corebids.com&gt;<br />
        This mailbox isn't monitored. Please don't reply. Contact support via your dashboard.
      </p>
    </div>
  );
};

export default EmailReportOrdered;
// CB:END email-preview-report-ordered


